import jwt_decode from 'jwt-decode'

/* eslint-disable import/no-anonymous-default-export */
export default {
    login: ({ phone, token, role }) => {
        localStorage.setItem('phone', phone);
        localStorage.setItem('userToken', token);
        localStorage.setItem('userRole', role);
        localStorage.removeItem('not_authenticated');
        return Promise.resolve()
    },
    logout: () => {
            localStorage.setItem('not_authenticated', 'true');         
            localStorage.removeItem('phone');
            localStorage.removeItem('userToken');
            return Promise.resolve();
    },
    checkError: ({ status }) => {
        return status === 401 || status === 403
            ? Promise.reject()
            : Promise.resolve();
    },
    checkAuth: () => {
        const userToken = localStorage.getItem('userToken');
        if (userToken === null) {
            return Promise.reject()
        } else {
            const { iat } = jwt_decode(userToken);
            if (iat < Math.floor(Date.now() / 1000 )) {
                return Promise.reject(); 
            }
            else return Promise.resolve();
        }

    },
    getPermissions: () => {    
        return Promise.reject('Unknown method')
    },
    getIdentity: () => {
        return Promise.resolve({
            fullName: localStorage.getItem('phone'),
        });
    },
}